import Arbor from "@/pages/catalogs/pages/arbors";
import Carrier from "@/pages/catalogs/pages/carriers";
import CassetteChock from "@/pages/catalogs/pages/cassette-chocks";
import Cassette from "@/pages/catalogs/pages/cassettes";
import Chock from "@/pages/catalogs/pages/chocks";
import Donut from "@/pages/catalogs/pages/donuts";
import EdgerRoll from "@/pages/catalogs/pages/edger-rolls";
import Guide from "@/pages/catalogs/pages/guides";
import UniversalRoll from "@/pages/catalogs/pages/universal-roll";

export const routeArbor = "/catalogs/arbors";
export const routeDonut = "/catalogs/donuts";
export const routeUniversalRoll = "/catalogs/universal-rolls";
export const routeEdgerRoll = "/catalogs/edger-rolls";
export const routeCarrier = "/catalogs/carriers";
export const routeCassette = "/catalogs/cassettes";
export const routeChock = "/catalogs/chocks";
export const routeCassetteChock = "/catalogs/cassette-chocks";
export const routeGuide = "/catalogs/guides";

export const catalogRoutes = [
	{
		path: `${routeArbor}`,
		element: <Arbor />,
		permission: "ui.navbar.catalogs.arbors",
	},
	{
		path: `${routeArbor}/:partId`,
		element: <Arbor />,
		permission: "ui.navbar.catalogs.arbors",
	},
	{
		path: `${routeDonut}`,
		element: <Donut />,
		permission: "ui.navbar.catalogs.donuts",
	},
	{
		path: `${routeDonut}/:partId`,
		element: <Donut />,
		permission: "ui.navbar.catalogs.donuts",
	},
	{
		path: `${routeUniversalRoll}`,
		element: <UniversalRoll />,
		permission: "ui.navbar.catalogs.universal.rolls",
	},
	{
		path: `${routeUniversalRoll}/:partId`,
		element: <UniversalRoll />,
		permission: "ui.navbar.catalogs.universal.rolls",
	},
	{
		path: `${routeEdgerRoll}`,
		element: <EdgerRoll />,
		permission: "ui.navbar.catalogs.edger.rolls",
	},
	{
		path: `${routeEdgerRoll}/:partId`,
		element: <EdgerRoll />,
		permission: "ui.navbar.catalogs.edger.rolls",
	},
	{
		path: `${routeCarrier}`,
		element: <Carrier />,
		permission: "ui.navbar.catalogs.carriers",
	},
	{
		path: `${routeCarrier}/:partId`,
		element: <Carrier />,
		permission: "ui.navbar.catalogs.carriers",
	},
	{
		path: `${routeCassette}`,
		element: <Cassette />,
		permission: "ui.navbar.catalogs.cassettes",
	},
	{
		path: `${routeCassette}/:partId`,
		element: <Cassette />,
		permission: "ui.navbar.catalogs.cassettes",
	},
	{
		path: `${routeChock}`,
		element: <Chock />,
		permission: "ui.navbar.catalogs.chocks",
	},
	{
		path: `${routeChock}/:partId`,
		element: <Chock />,
		permission: "ui.navbar.catalogs.chocks",
	},
	{
		path: `${routeCassetteChock}`,
		element: <CassetteChock />,
		permission: "ui.navbar.catalogs.cassette.chocks",
	},
	{
		path: `${routeCassetteChock}/:partId`,
		element: <CassetteChock />,
		permission: "ui.navbar.catalogs.cassette.chocks",
	},
	{
		path: `${routeGuide}`,
		element: <Guide />,
		permission: "ui.navbar.catalogs.guides",
	},
	{
		path: `${routeGuide}/:partId`,
		element: <Guide />,
		permission: "ui.navbar.catalogs.guides",
	},
];
